<template>
  <div>
    <el-row>
      <el-col :sm="24" :md="12" :lg="8">
        <el-form label="教学计划" prop="type" style="width: 800px;padding-top: 20px">
          查询学员id:
          <el-input v-model="addMinShengItemForm.studentId" placeholder="填写查询学员id"
                    style="width: 350px"></el-input>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="padding-top: 20px">
      <el-button
        type="primary"
        @click="getSubjectListByStudent"
        icon="el-icon-search"
      >查询学员绑定的教学计划和科目
      </el-button>
    </el-row>


    <el-row>
      <el-col :sm="24" :md="12" :lg="8">
        <el-form label="教学计划" prop="type" style="width: 800px;padding-top: 20px">
          教学计划:
          <el-select v-model="addMinShengItemForm.teachPlanId" placeholder="选择民生教学计划" style="width: 350px">
            <el-option v-for="(item, index) in minShengTeachPlanAndSubjectTreeList" :key="index"
                       :label="item.teachPlanName" :value="item.teachPlanId"
                       @click.native="selectSubjectListByTeachPlanId"></el-option>
          </el-select>
        </el-form>
      </el-col>
    </el-row>

    <el-row>
      <el-col :sm="24" :md="12" :lg="8">
        <el-form label="科目" prop="type" style="width: 800px;padding-top: 20px">
          科目:
          <el-select v-model="addMinShengItemForm.subjectId" placeholder="选择科目" style="width: 350px">
            <el-option v-for="(item, index) in minShengSubjectList" :key="index" :label="item.subjectName"
                       :value="item.subjectId"></el-option>
          </el-select>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="padding-top: 20px">
      <el-button
        type="primary"
        @click="getExamBySubject"
        icon="el-icon-search"
      >查询民生试卷
      </el-button
      >
      <el-button
        type="primary"
        @click="getKnowledgeQuestionBySubject"
        icon="el-icon-search"
      >查询民生知识点习题
      </el-button
      >
    </el-row>
    <el-dialog :visible.sync="examListShow" title="民生试卷">
      <el-table
        ref="multipleTable"
        :data="minShengExamList"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        height="520"
        border
      >
        <el-table-column prop="paperName" label="试卷名称"></el-table-column>
        <el-table-column prop="tagName" label="类型"></el-table-column>
        <el-table-column prop="questionCount" label="试题数量"></el-table-column>
        <el-table-column prop="totalScore" label="总分"></el-table-column>
        <el-table-column prop="duration" label="考试时长"></el-table-column>
        <el-table-column prop="remak" label="描述"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop
          label="操作"
          align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <i
                class="iconfont iconbianji mainColor"
                @click="examInfo(scope.row.id)"
                title="概况"
              ></i>
              <i
                class="iconfont icondaoru1 mainColor"
                @click="exportExamExcel(scope.row.id)"
                :loading="loading"
                icon="el-icon-download"
                title="导出"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="章节知识点" :visible.sync="knowledgeQuestionListShow" >
      <div class="block">
        <el-tree
          v-loading="webLoading"
          :data="minShengKnowledgeQuestionList"
          ref="tree"
          node-key="id"
          :expand-on-click-node="false"
          :default-expand-all="false"
        >
           <span class="span-ellipsis" slot-scope="{ node, data }">
            <span>
              <span style="margin-left:10px">{{ data.name }}</span>
            </span>
            <span v-if="data.children == null">
              <span style="margin-left:10px;color:#409eff " @click="exportKnowledgeInfo(data.id)">概况</span>
            </span>
               <span v-if="data.children == null">
              <span style="margin-left:10px;color: #409eff" @click="exportKnowledgeExcel(data.id,data.name)">导出</span>
            </span>
          </span>

        </el-tree>
      </div>
    </el-dialog>
<!--    习题概况信息展示-->
    <el-dialog  :visible.sync="generalizeInfoShow" >
      <div class="block">
        <el-alert title="习题概况" v-model="generalizeInfoStr"></el-alert>
      </div>

    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: {
        rows: [],
        total: 0,
        pageSize: 20,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      generalizeInfoStr:"",
      generalizeInfoShow:false,
      examListShow: false,
      knowledgeQuestionListShow: false,
      minShengExamList: [],//民生试卷集合
      examDetailsShow: false,//试卷详情页
      minShengKnowledgeQuestionList: [],//民生知识点习题集合
      webLoading: false,
      addMinShengItemForm: {
        productId: "",
        subjectId: "",//科目id
        teachPlanId: "",
        courseId: "",
        periodId: "",
        studentId: ""
      },
      minShengTeachPlanAndSubjectTreeList: [],//民生产品下教学计划
      minShengSubjectList: [],//教学计划科目集合

      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      Loading: false,
      searchForm: {},
      addForm: {
        name: "",
        mode: "",
        remark: "",
        big: ""
      },
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入题型名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "题型名称长度在1到255个字"
          }
        ],
        mode: [
          {
            required: true,
            message: "请选择模式",
            trigger: "blur"
          }
        ],
        big: [
          {
            required: true,
            message: "请选择大题",
            trigger: "blur"
          }
        ],
        remark: [],
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确"
          }
        ]
      },
      editForm: {
        name: "",
        mode: "",
        remark: "",
        big: ""
      },
      editFormRules: {
        big: [
          {
            required: true,
            message: "请选择大题",
            trigger: "blur"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入题型名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "题型名称长度在1到255个字"
          }
        ],
        mode: [
          {
            required: true,
            message: "请输入模式",
            trigger: "blur"
          }
        ],
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确"
          }
        ],
        remark: []
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],

      fileAction: `${process.env.BASE_URL}/questionType/upload`,
      fileList: [],
      loading: false
    };
  },
  methods: {

    getSubjectListByStudent() {
      if (this.addMinShengItemForm.studentId == '') {
        this.$message.error("请输入查询学员id")
        return
      }
      let param = {
        studentId: this.addMinShengItemForm.studentId
      };
      this.api.minShengCourseInfo
        .getSubjectListByStudent(param)
        .then((result) => {
          if (result.success) {
            this.minShengTeachPlanAndSubjectTreeList = result.data;
            this.minShengSubjectList = [];
            this.$message.success("查询完成，请选择教学计划！");
          } else {
            this.$message(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectSubjectListByTeachPlanId() {
      this.minShengSubjectList = [];
      for (let item of this.minShengTeachPlanAndSubjectTreeList) {
        if (this.addMinShengItemForm.teachPlanId == item.teachPlanId) {
          this.minShengSubjectList = item.openResourceSubjectDtoList;
          break;
        }
      }
    },
    getKnowledgeQuestionBySubject() {
      if (this.addMinShengItemForm.studentId == '') {
        this.$message.error("请输入查询学员id")
        return
      }
      if (this.addMinShengItemForm.teachPlanId == '') {
        this.$message.error("请选择教学计划")
        return
      }
      if (this.addMinShengItemForm.subjectId == '') {
        this.$message.error("请选择科目")
        return
      }
      let param = {
        studentId: this.addMinShengItemForm.studentId,
        teachPlanId: this.addMinShengItemForm.teachPlanId,
        subjectId: this.addMinShengItemForm.subjectId
      };
      this.api.minShengCourseInfo
        .getKnowledgeSystemTreeBySubject(param)
        .then((result) => {
          if (result.success) {
            if (result.data.length == 0) {
              this.$message.info("查无知识点信息")
            }
            this.examListShow = false;
            this.minShengKnowledgeQuestionList = result.data;
            this.knowledgeQuestionListShow = true;
          } else {
            this.$message(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getExamBySubject() {
      if (this.addMinShengItemForm.studentId == '') {
        this.$message.error("请输入查询学员id")
        return
      }
      if (this.addMinShengItemForm.teachPlanId == '') {
        this.$message.error("请选择教学计划")
        return
      }
      if (this.addMinShengItemForm.subjectId == '') {
        this.$message.error("请选择科目")
        return
      }
      let param = {
        studentId: this.addMinShengItemForm.studentId,
        teachPlanId: this.addMinShengItemForm.teachPlanId,
        subjectId: this.addMinShengItemForm.subjectId
      };
      this.api.minShengCourseInfo
        .getListPaperByStudent(param)
        .then((result) => {
          if (result.success) {
            if (result.data.length == 0) {
              this.$message.info("查无试卷信息")
            }
            this.minShengExamList = result.data;
            this.examListShow = true;
            this.knowledgeQuestionListShow = false;
          } else {
            this.$message(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    examInfo(id) {
      let param = {
        studentId: this.addMinShengItemForm.studentId,
        teachPlanId: this.addMinShengItemForm.teachPlanId,
        subjectId: this.addMinShengItemForm.subjectId,
        paperId: id
      };
      this.api.minShengCourseInfo
        .getPaperDetailInfoByStudent(param)
        .then((result) => {
          if (result.success) {
            let data = result.data;
            if (!data) {
              this.$message.info("查无试卷信息")
            }
            let str = '试卷名称： ' + data.paperName + "\n";
            str += '总题目数： ' + data.questionCount + "\n";
            str += '试卷描述： ' + (data.remak == null ? '' : data.remak) + "\n";
            str += '总分： ' + data.totalScore + "\n";
            let i = 1;
            for (let item of data.groupList) {
              str += "第" + i + "大题：" + item.topic + "\n";
              str += "题目数量：" + item.questionList.length + "\n";
              i++;
            }
            alert(str);
          } else {
            this.$message(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    exportExamExcel(id) {
      let param = {
        studentId: this.addMinShengItemForm.studentId,
        teachPlanId: this.addMinShengItemForm.teachPlanId,
        subjectId: this.addMinShengItemForm.subjectId,
        paperId: id
      };
      this.loading = true;
      this.api.minShengCourseInfo
        .exportExamExcel(param)
        .then(result => {
          if (result.success) {
            if (result.data.indexOf("https") == -1) {
              result.data = result.data.replace("http", "https");
            }
            location.href = result.data;
          } else {
            this.$message(result.message);
          }
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //知识点习题概况
    exportKnowledgeInfo(id) {
      let param = {
        studentId: this.addMinShengItemForm.studentId,
        teachPlanId: this.addMinShengItemForm.teachPlanId,
        subjectId: this.addMinShengItemForm.subjectId,
        knowledgeSystemId: id
      };
      this.api.minShengCourseInfo
        .getOpenQusetionInfoByKnowledgeSystemId(param)
        .then((result) => {
          if (result.success) {
            let data = result.data;
            if (!data) {
              this.$message.info("知识点未绑定试题信息")
            }
            let str = '';
            str += '总题目数： ' + data.length + "\n";
            var objNew = {};
            data.map((item) => {
              if (!objNew[item.questionTypeDesc]) {
                objNew[item.questionTypeDesc] = [];
              }
              objNew[item.questionTypeDesc].push(item);
            });
            console.info(objNew);
            str += '题型与数目概况:' + "\n";
            for (let key in objNew) {
              str += key + "--" + objNew[key].length + "\n";
            }
            alert(str);
            // this.generalizeInfoStr = str;
            // this.generalizeInfoShow = true;
          } else {
            this.$message(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    exportKnowledgeExcel(id, name) {
      let param = {
        studentId: this.addMinShengItemForm.studentId,
        teachPlanId: this.addMinShengItemForm.teachPlanId,
        subjectId: this.addMinShengItemForm.subjectId,
        knowledgeSystemId: id,
        knowledgeSystemName: name
      };
      this.loading = true;
      this.api.minShengCourseInfo
        .exportKnowledgeExcel(param)
        .then(result => {
          if (result.success) {
            if (result.data.indexOf("https") == -1) {
              result.data = result.data.replace("http", "https");
            }
            location.href = result.data;
          } else {
            this.$message(result.message);
          }
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },



    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({id: e.id}));
    },
    getQuestionType() {
      this.api.questionType
        .getQuestionType({
          id: this.selection
        })
        .then(result => {
          result.data.big = String(result.data.big);
          this.editForm = result.data;
          this.editFormVisible = true;
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList() {
      this.Loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.questionType
        .pageList(this.searchForm)
        .then(result => {
          this.Loading = false;
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addQuestionType() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.questionType
            .addQuestionType(this.addForm)
            .then(result => {
              if (result.success) {
                this.$message.success(result.message);
                this.addFormVisible = false;
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateQuestionType() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.api.questionType
            .updateQuestionType(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteQuestionType(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.questionType
            .deleteQuestionType([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {
        });
    },
    batchDeleteQuestionType() {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.questionType
            .deleteQuestionType(this.ids)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {
        });
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },


    importData() {
      this.api.questionType
        .importData(this.importForm.rows)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
          this.pageList();
          this.importFormVisible = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  watch: {
    "editForm.big": function (newVal) {
      console.log(1111, newVal);
      if (newVal == 1) {
        this.editFormRules.mode = [
          {
            required: false,
            message: "请选择模式",
            trigger: "blur"
          }
        ];
      } else {
        this.editFormRules.mode = [
          {
            required: true,
            message: "请选择模式",
            trigger: "blur"
          }
        ];
      }
    },
    "addForm.big": function (newVal) {
      if (newVal == 1) {
        this.addFormRules.mode = [
          {
            required: false,
            message: "请选择模式",
            trigger: "blur"
          }
        ];
      } else {
        this.addFormRules.mode = [
          {
            required: true,
            message: "请选择模式",
            trigger: "blur"
          }
        ];
      }
    },

    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
      }
    }
  },
  mounted() {

  }
};
</script>



// WEBPACK FOOTER //
// src/components/questionBankByMinSheng/index.vue